var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgSettingsWhite = function SvgSettingsWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M20.326 15.716l-.616 1.068a1.891 1.891 0 01-2.578.697 1.882 1.882 0 00-2.579.669 1.81 1.81 0 00-.253.905A1.891 1.891 0 0112.409 21h-1.24a1.882 1.882 0 01-1.881-1.891 1.891 1.891 0 00-1.891-1.864c-.319.003-.631.09-.905.254a1.891 1.891 0 01-2.579-.697l-.66-1.086a1.891 1.891 0 01.687-2.578 1.89 1.89 0 000-3.276 1.882 1.882 0 01-.687-2.57l.624-1.076a1.891 1.891 0 012.579-.733 1.873 1.873 0 002.57-.687 1.81 1.81 0 00.253-.905A1.89 1.89 0 0111.169 2h1.24c1.04 0 1.886.841 1.891 1.882a1.882 1.882 0 001.89 1.89 1.93 1.93 0 00.906-.252 1.891 1.891 0 012.578.687l.652 1.086a1.882 1.882 0 01-.688 2.578 1.882 1.882 0 00-.688 2.579c.164.286.402.524.688.688a1.891 1.891 0 01.688 2.57v.008z",
    stroke: "#fff",
    strokeOpacity: 0.8,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.794 8.894a2.606 2.606 0 110 5.212 2.606 2.606 0 010-5.212z",
    stroke: "#fff",
    strokeOpacity: 0.8,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgSettingsWhite;